import React from "react";
import classNames from "classnames";
import {
   Modal,
   ModalBody,
   ModalFooter,
   ModalHeader,
   ModalProps,
   SpinningButton,
} from "Components/ReactstrapSlim";
import { DesignContextProvider } from "Components/DesignContext";
import { Check, LineGraph, Members } from "Components/Icons";
import BenefitItem from "./BenefitItem";

import imgCard from "Assets/img/XPP/BenefitsPopUp/Card.png";
import gradientLine from "Assets/img/XPP/BenefitsPopUp/GradientLine.svg";
import gradientCircle from "Assets/img/XPP/BenefitsPopUp/GradientCircle.svg";

import classes from "./BenefitsPopUp.module.scss";

const BENEFIT_LIST = [
   {
      title: "Earn more revenue",
      description:
         "Monetize your spaces by listing desks, offices, and meeting rooms at your own terms and prices for any duration.",
      icon: <LineGraph />,
   },
   {
      title: "Access to new clients",
      description:
         "Connect with large companies, start-up and individuals. Our sales & marketing teams handle the hard work for you.",
      icon: <Members />,
   },
   {
      title: "Free and flexible",
      description:
         "Create a free profile, set your availability, hours, and pricing, and earn money with each successful booking.",
      icon: <Check />,
   },
];

export interface BenefitsPopUpProps extends ModalProps {
   toggle?: () => void;
   onClaim?: () => void;
}

const BenefitsPopUp: React.FC<BenefitsPopUpProps> = ({
   modalClassName,
   contentClassName,
   toggle,
   onClaim,
   isLoading,
   ...props
}) => (
   <DesignContextProvider name="primary">
      <Modal
         centered
         backdrop="static"
         size="lg"
         modalClassName={classNames(classes.modal, modalClassName)}
         contentClassName={classNames(classes.modalContent, contentClassName)}
         {...props}
      >
         <div className={classes.imgContainer}>
            <img
               className={classes.gradientCircle}
               src={gradientCircle}
               alt="Gradient circle"
            />
            <img
               className={classes.gradientLine}
               src={gradientLine}
               alt="Gradient line"
            />
            <img
               className={classes.benefitImg}
               src={imgCard}
               alt="benefit img"
            />
         </div>
         <div className={classes.contentContainer}>
            <ModalHeader toggle={isLoading ? undefined : toggle} className={classes.modalHeader}>
               Don't miss out on revenue opportunities today!
            </ModalHeader>
            <ModalBody>
               <div className={classes.benefitList}>
                  {BENEFIT_LIST.map((item, i) => (
                     <BenefitItem
                        key={i}
                        title={item.title}
                        description={item.description}
                        icon={item.icon}
                     />
                  ))}
               </div>
            </ModalBody>
            <ModalFooter>
               <SpinningButton
                  size="lg"
                  color="primary"
                  className={classes.modalCta}
                  onClick={onClaim}
                  isLoading={isLoading}
               >
                  Claim your profile
               </SpinningButton>
            </ModalFooter>
         </div>
      </Modal>
   </DesignContextProvider>
);

export default BenefitsPopUp;
